<template>
  <ul class="app-product-information-list">
    <ProductInformationItem v-for="productInformation in productInformationList" :key="productInformation.productIdentifier" :product-information="productInformation">
      <template v-for="slot in possibleChildSlotsFor('Product', productInformation.productIdentifier)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProductInformationItem>
  </ul>
</template>

<script>

import slotProxy from '../../../../mixins/slotProxy'

/**
 * Diese Komponente stellt eine Liste von ProductInformationen dar.
 * Dabei ist die Darstellung eines Items nicht spezifisch festgelegt.
 * Es existieren derzeit 2 Implementierungen:
 * - ProductInformationItemRecent (Stellt nur die aktuelle Version dar)
 * - ProductInformationItemVersions (Stellt einen Collapse dar, der eine Liste von Sheets enthällt, die
 *   aktuelle gefolgt von der Liste der alten Versionen)
 * Welche Komponente verwendet wird, muss in der [brand].js festgelegt werden:
 * Vue.component('ProductInformationItem', ProductInformationItemVersions)
 */
export default {
  mixins: [
    slotProxy()
  ],
  props: {
    productInformationList: {
      type: Array,
      default: () => []
    }
  },
  name: 'ProductInformationList'
}
</script>
